module.exports = __webpack_public_path__ + "img/marker_two_red3.ed52f4b3.png";